import { EnumType } from "./enumType";

export type Dir = "ltr" | "rtl";

export const DIR: EnumType<Dir> = {
  ltr: "ltr",
  rtl: "rtl",
};
